/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	ErrorMessage,
	ErrorMessageFromJSON,
	ErrorMessageFromJSONTyped,
	ErrorMessageToJSON,
} from "./ErrorMessage";
import {
	EvaluationDTO,
	EvaluationDTOFromJSON,
	EvaluationDTOFromJSONTyped,
	EvaluationDTOToJSON,
} from "./EvaluationDTO";

/**
 *
 * @export
 * @interface EvaluationDTORequestResponse
 */
export interface EvaluationDTORequestResponse {
	/**
	 *
	 * @type {EvaluationDTO}
	 * @memberof EvaluationDTORequestResponse
	 */
	response?: EvaluationDTO;
	/**
	 *
	 * @type {ErrorMessage}
	 * @memberof EvaluationDTORequestResponse
	 */
	errorMessage?: ErrorMessage;
}

export function EvaluationDTORequestResponseFromJSON(
	json: any
): EvaluationDTORequestResponse {
	return EvaluationDTORequestResponseFromJSONTyped(json, false);
}

export function EvaluationDTORequestResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): EvaluationDTORequestResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		response: !exists(json, "response")
			? undefined
			: EvaluationDTOFromJSON(json["response"]),
		errorMessage: !exists(json, "errorMessage")
			? undefined
			: ErrorMessageFromJSON(json["errorMessage"]),
	};
}

export function EvaluationDTORequestResponseToJSON(
	value?: EvaluationDTORequestResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		response: EvaluationDTOToJSON(value.response),
		errorMessage: ErrorMessageToJSON(value.errorMessage),
	};
}
